import { supabase } from "../supabase";
import { validateCoupon } from "./helpers";

// Callers normalize the code and retain their own UI and referral-storage effects.
export async function resolveDiscountCode(code, postBulk) {
  const { data: rpcData, error } = await supabase.rpc("validate_coupon", { p_code: code });
  if (!error && rpcData && rpcData.length > 0) {
    const c = rpcData[0];
    // Expiry and usage eligibility remain the RPC's responsibility.
    const coupon = { code, type: c.coupon_type, value: c.value, min_subtotal: c.min_subtotal, active: true };
    const validation = validateCoupon(coupon, postBulk);
    return validation.valid ? { coupon } : { error: validation.reason };
  }

  const { data: affiliate } = await supabase.from("affiliates").select("code, commission_value")
    .eq("code", code).eq("active", true).maybeSingle();
  if (affiliate) {
    return { coupon: { code: affiliate.code, type: "percent", value: Number(affiliate.commission_value), min_subtotal: 0, active: true, isAffiliate: true } };
  }
  return { error: "Invalid coupon or affiliate code." };
}
